export const RATE_LIMIT_STORAGE_KEY = 'rateLimitContext'
export const RATE_LIMIT_PAGE_PATH = '/rate-limited'
export const RATE_LIMIT_DELAY = 20 * 1000
export const SOLIDSPORT_SUPPORT_URL =
  'https://solidsport.freshdesk.com/support/home'
